//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "payforList",
    data() {
        return {
            value: "",
            isDefauMore: true,
            select_id: 0
        }
    },
    props: {
        listData: {
            type: Array,
            default: []
        },
    },
    created() {
        let listData = this.listData;
        this.select_id = listData[0].id
    },
    mounted() {
        // console.log('输出信息:', this.value);
    },
    methods: {
        handleSwitch(val) {
            console.log('改变:', val);
        },
        choosePayfor(idx) {
            let listData = this.listData;
            let id = this.listData[idx].id;
            // console.log('输出选中的内容:', idx, id, listData);
            this.select_id = id;
            // if (select_id != "") {
            //   this.select_id = id
            // }
            // listData[idx]
        },
        moreData() {
            this.isDefauMore = false
        }
    },
    watch: {
        select_id(val) {
            console.log('输出信息:', val);
            this.$emit("switch", val)
        }
    },
}



// WEBPACK FOOTER //
// ./src/component/payforList/index.vue